import React, {useEffect} from "react";
import {CCNLLivelloRecord} from "@commons/mapping/SettoriCCNL";
import {Controller, useForm} from "react-hook-form";
import Select from "../../../components/wrapperComponents/Select";
import InputEx from "../../../components/wrapperComponents/InputEx";
import FormButtons from "../../../components/FormButtons";
import * as Validation from "@utilities/validationRules";
import DatePickerWrapper from "../../../components/DataPickerWrapper";
import TextAreaEx from "../../../components/wrapperComponents/TextAreaEx";
import {IntegerInputEx} from "../../../components/wrapperComponents/IntegerInputEx";

interface CCNLLivelloEditorProps {
    defaultValues: CCNLLivelloRecord,
    resource: CCNLLivelloRecord;
    onSubmit: (formData: CCNLLivelloRecord) => void,
    onCancel: () => void;
}

const CCNLLivelliEditor: React.FC<CCNLLivelloEditorProps> = ({defaultValues, resource, onSubmit, onCancel}) => {
    const currentValues: CCNLLivelloRecord = {
        ...defaultValues,
        ...resource,
    };
    const {register, control, watch, handleSubmit, reset, formState: {errors}} = useForm<CCNLLivelloRecord>({defaultValues: {ordinamento: 0} as CCNLLivelloRecord});

    useEffect(() => reset(currentValues), [resource]);

    function onHandleSubmit(newValues: CCNLLivelloRecord) {
        onSubmit({
            ...newValues,
        })
    }

    const watchDescrizioneUNILAV = watch('descrizioneUNILAV');
    const descrUNILAV = watchDescrizioneUNILAV ? watchDescrizioneUNILAV.length : 0

    return <>
        <form className="space-y-8 divide-y divide-gray-200 pt-8" onSubmit={handleSubmit(onHandleSubmit)}>
            <div className="flexRowWrapFull">
                <div className="sm2-6P">
                    <InputEx
                        label="Codice livello"
                        name="codLivello"
                        register={register}
                        registerOptions={Validation.required}
                        errors={errors}
                        maxLength={6}
                    />
                </div>
                <div className="sm2-6P">
                    <InputEx
                        label="Codice ministeriale"
                        name="codLivelloUNILAV"
                        register={register}
                        registerOptions={Validation.required}
                        errors={errors}
                        maxLength={6}
                    />
                </div>

                <Select label="Tipo" name="tipologia" divClass="sm2-6P"
                        register={register} registerOptions={Validation.required} errors={errors}>
                    {<>
                        <option key="NON_DEFINITO" value="NON_DEFINITO">Non definito</option>
                        <option key="QUALIFICATO" value="QUALIFICATO">Qualificato</option>
                        <option key="APPRENDISTA" value="APPRENDISTA">Apprendista</option>
                    </>}
                </Select>

            </div>

            <div className="flexRowWrapFull">
                <div className="sm2-6P">
                    <IntegerInputEx label="Ordinamento" name="ordinamento" control={control} min={0} max={999}/>
                </div>
                <div className="sm4-6P">
                    <TextAreaEx name="descrizioneUNILAV" id="descrizioneUNILAV" label="Descrizione ministeriale"
                                rows={4} register={register} registerOptions={Validation.required} maxLength={60} errors={errors}
                                textLength={descrUNILAV} totalChars={60}/>
                </div>
            </div>

            <div className="flexRowWrapFull">
                <div className="sm2-6P">
                    <IntegerInputEx label="Numero mensilità" name="numMensilita" control={control} min={1} max={14}/>
                </div>
                <div className="sm2-6P">
                    <InputEx
                        label="Divisore orario"
                        name="divisoreOrario"
                        register={register}
                        registerOptions={{...Validation.required, ...Validation.minNumber(1)}}
                        errors={errors}
                        type="number"
                    />
                </div>
                <div className="sm2-6P">
                    <InputEx
                        label="RML"
                        name="rml"
                        register={register}
                        registerOptions={Validation.required}
                        errors={errors}
                    />
                </div>
            </div>

            <fieldset className="flexRowWrapFull border border-gray-200 pb-3 px-3">
                <legend className="px-2">Validit&agrave;</legend>
                <div className="sm1-3P">
                    <label className="block text-sm font-semibold mb-1" htmlFor="validitaInizio">Data inizio</label>
                    <Controller name="inizioValidita" control={control}
                                render={({field: {value, onChange}, fieldState, formState}) =>
                                    (<DatePickerWrapper fieldState={fieldState} value={value} onChange={onChange} enabled/>)
                                }
                    />
                </div>
                <div className="sm1-3P">
                    <label className="block text-sm font-semibold mb-1" htmlFor="fineValidita">Data fine</label>
                    <Controller name="fineValidita" control={control}
                                render={({field: {value, onChange}, fieldState, formState}) =>
                                    (<DatePickerWrapper fieldState={fieldState} value={value} onChange={onChange} enabled/>)
                                }
                    />
                </div>
            </fieldset>

            <FormButtons onCancel={onCancel} resource={resource}/>
        </form>
    </>
}

export default CCNLLivelliEditor;
